var render = function render(){var _vm=this,_c=_vm._self._c;return _c('optgroup',{class:`cv-select-optgroup ${_vm.carbonPrefix}--select-optgroup`},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }